import { Button } from "@similarweb/ui-components";

import { translate } from "app/filters/i18nFilter";

interface IStartNewSearchButtonProps {
    onClick: () => void;
}
const StartNewSearchButton = ({ onClick }: IStartNewSearchButtonProps) => {
    return (
        <Button
            type="outlined"
            onClick={onClick}
        >
            {translate("si.advanced-search.save-search-reminder.button.start-new-search")}
        </Button>
    );
};

export default StartNewSearchButton;
